import { render } from "./layout-box.vue?vue&type=template&id=aa06def0&scoped=true"
import script from "./layout-box.vue?vue&type=script&lang=js"
export * from "./layout-box.vue?vue&type=script&lang=js"

import "./layout-box.vue?vue&type=style&index=0&id=aa06def0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa06def0"]])

export default __exports__